export default __webpack_public_path__ + "static/media/1.c0f46f96.png";